import { EXAM_DATA } from './exam-data.js';
/** Published v3 question order is stable, just like the earlier challenge banks. */
export const EXAM_PACK_SETS = EXAM_DATA.questions.map(({ drawings, ...set }) => ({
    ...set,
    source: 'pack',
    render(features) {
        const index = set.sentences.findIndex((sentence) => set.axes.every((axis) => sentence.features[axis.name] === features[axis.name]));
        if (index < 0)
            throw new Error(`Unknown features for ${set.id}`);
        return drawings[index].map((id) => EXAM_DATA.strokes[id]);
    },
}));
//# sourceMappingURL=exam-pack.js.map